// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2k3in","requiredAsterisk":"Info_requiredAsterisk__2BKeP"};